// src/pages/admin/ViewJewelleryPage.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ViewJewelleryPage = () => {
  const [jewelleryItems, setJewelleryItems] = useState([]);
  const [filter, setFilter] = useState('ALL');
  const [searchTerm, setSearchTerm] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJewelleryItems = async () => {
      try {
        const response = await axios.get('/api/jewellery');
        setJewelleryItems(response.data);
      } catch (error) {
        console.error('Error fetching jewellery items:', error);
        setError('Error fetching jewellery items');
      }
    };

    fetchJewelleryItems();
  }, []);

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredItems = jewelleryItems.filter((item) => {
    if (filter === 'ALL') return true;
    return item.category === filter;
  }).filter((item) => {
    if (!searchTerm) return true;
    return item.name.toLowerCase().includes(searchTerm.toLowerCase());
  });

  return (
    <div>
      <h1>Jewellery Items</h1>
      <div>
        <select onChange={handleFilterChange}>
          <option value="ALL">All Categories</option>
          <option value="BANGLES">Bangles</option>
          <option value="BRACELETS">Bracelets</option>
          <option value="EARRINGS">Earrings</option>
          <option value="GOLD CHAINS">Gold Chains</option>
          <option value="PENDANTS">Pendants</option>
          <option value="RINGS">Rings</option>
          <option value="ENGAGEMENT RINGS">Engagement Rings</option>
          <option value="NECKLACES">Necklaces</option>
          <option value="NOSE PINS">Nose Pins</option>
          <option value="KADAS">Kadas</option>
          <option value="MANGALSUTRAS">Mangalsutras</option>
          <option value="JHUMKAS">Jhumkas</option>
          <option value="HOOP EARRINGS">Hoop Earrings</option>
          <option value="STUD EARRINGS">Stud Earrings</option>
          <option value="DROP EARRINGS">Drop Earrings</option>
          <option value="MAANG TIKKA">Maang Tikka</option>
          <option value="NECKLACE SET">Necklace Set</option>
          <option value="PENDANTS & EARRINGS SETS">Pendants & Earrings Sets</option>
          <option value="MEN">Men</option>
          <option value="BRACELETS">Bracelets</option>
          <option value="CHAINS">Chains</option>
          <option value="ENGAGEMENT RINGS">Engagement Rings</option>
          <option value="KADAS">Kadas</option>
          <option value="PENDANTS">Pendants</option>
        </select>
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </div>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <div className="jewellery-list">
        {filteredItems.length > 0 ? (
          filteredItems.map((item) => (
            <div key={item._id} className="jewellery-item">
              <img src={item.imageUrl} alt={item.name} />
              <h2>{item.name}</h2>
              <p>{item.description}</p>
              <p>Category: {item.category}</p>
              <p>Price: {item.price}</p>
            </div>
          ))
        ) : (
          <p>No jewellery items found</p>
        )}
      </div>
    </div>
  );
};

export default ViewJewelleryPage;
